import { Component, inject, Optional } from '@angular/core';
import {
  FilterViewProviderDirective,
  ItemActionResult,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  Util,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { first, map, Observable, startWith, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-new-klasa-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class NewKlasaActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override itemProvider: ItemProvider
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  filterViewProviderDirective = inject(FilterViewProviderDirective);
  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    return this.filterViewProviderDirective.viewData$.pipe(
      startWith({}),
      first(),
      map((filterState: any) => {
        const klas_plan = 'seup.klasa.klasifikacijski_plan_id';
        const FQAN_klas_plan = Util.getFullAttrName(
          'seup~klasa',
          'klasifikacijski_plan_id'
        );
        if (filterState[klas_plan] && !item[FQAN_klas_plan]) {
          item[FQAN_klas_plan] = filterState[klas_plan];
        }
        return item;
      }),
      switchMap(() => {
        return super.doExecuteWithItem(item).pipe(
          tap(() => this.listViewProvider.refresh()),
          map(() => {
            return { result: {} } as ItemActionResult;
          })
        );
      })
    );
  }
}
